"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capMapToObj = capMapToObj;
// convert a capability map to an object so qs.stringify works
function capMapToObj(capMap) {
    const capToEnabled = {};
    for (const [cap, enabled] of capMap.entries()) {
        capToEnabled[cap] = enabled;
    }
    return capToEnabled;
}
//# sourceMappingURL=capMapToObj.js.map